var _defineProperty = require("/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _toConsumableArray = require("/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/codebuild/output/src285158505/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var $bctdY$lodash = require("lodash");
var $bctdY$sparkpostdesigntokens = require("@sparkpost/design-tokens");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function (key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }
    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });
  return dest;
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "HIBANA_METRICS_COLORS", function () {
  return $5d9b09857b8fa08e$export$c3f418cdae11e815;
});
$parcel$export(module.exports, "categories", function () {
  return $5d9b09857b8fa08e$export$2c76aca27257bcfa;
});
$parcel$export(module.exports, "REPORT_BUILDER_FILTER_KEY_MAP", function () {
  return $5d9b09857b8fa08e$export$e143335c1543628;
});
$parcel$export(module.exports, "REPORT_BUILDER_FILTER_KEY_INVERTED_MAP", function () {
  return $5d9b09857b8fa08e$export$938bb5fdbf904224;
});
$parcel$export(module.exports, "PREFETCHED_KEY", function () {
  return $5d9b09857b8fa08e$export$3a28e3a2b7e54f6;
});
$parcel$export(module.exports, "NON_PREFETCHED_KEY", function () {
  return $5d9b09857b8fa08e$export$b62ef4c67ed4b184;
});
$parcel$export(module.exports, "nonPrefetchedMetrics", function () {
  return $5d9b09857b8fa08e$export$d334702e3b05c761;
});
$parcel$export(module.exports, "list", function () {
  return $5d9b09857b8fa08e$export$8837f4fc672e936d;
});
$parcel$export(module.exports, "deliverabilityList", function () {
  return $5d9b09857b8fa08e$export$e02e63fda0b3a81c;
});
$parcel$export(module.exports, "bounceTabMetrics", function () {
  return $5d9b09857b8fa08e$export$13acb3da2d2f7436;
});
$parcel$export(module.exports, "rejectionTabMetrics", function () {
  return $5d9b09857b8fa08e$export$f50be4e64d945ebd;
});
$parcel$export(module.exports, "delayTabMetrics", function () {
  return $5d9b09857b8fa08e$export$dce03f1dce1dbb81;
});
$parcel$export(module.exports, "linksTabMetrics", function () {
  return $5d9b09857b8fa08e$export$20e66e155200ce;
});
$parcel$export(module.exports, "DELIVERABILITY_BOUNCE_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$93a3932e55e08b73;
});
$parcel$export(module.exports, "DELIVERABILITY_DELAY_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$3153a1856b13a66c;
});
$parcel$export(module.exports, "DELIVERABILITY_REJECTION_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$d83bf8754cc127f4;
});
$parcel$export(module.exports, "DELIVERABILITY_LINKS_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$88586c7bba3bcfca;
});
$parcel$export(module.exports, "LINKS_BY_DOMAIN_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$dfab43b0ae5b287f;
});
$parcel$export(module.exports, "REJECTIONS_BY_DOMAIN_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$3b5f7e0951e03e2d;
});
$parcel$export(module.exports, "BOUNCE_BY_DOMAIN_METRIC_KEYS", function () {
  return $5d9b09857b8fa08e$export$56c8589eebb696c7;
});
$parcel$export(module.exports, "map", function () {
  return $5d9b09857b8fa08e$export$871de8747c9eaa88;
});
$parcel$export(module.exports, "categorizedMetricsList", function () {
  return $5d9b09857b8fa08e$export$24fdeceee7dce9f;
});
$parcel$export(module.exports, "INDUSTRY_BENCHMARK_METRICS_MAP", function () {
  return $5d9b09857b8fa08e$export$316876556a26de9d;
});
$parcel$export(module.exports, "METRICS_UNIT_CONFIG", function () {
  return $5d9b09857b8fa08e$export$224b14d28c9ae256;
});
var $06d2d9de361ad358$exports = {};
var $bf39c630334f29ae$exports = {};
$parcel$export($bf39c630334f29ae$exports, "cumulativeSum", function () {
  return $bf39c630334f29ae$export$9e57366c37a5642e;
});
function $bf39c630334f29ae$export$9e57366c37a5642e(_ref) {
  var data1 = _ref.data,
    key = _ref.key;
  var results = data1.reduce(function (cumulativeDataSet, data) {
    var cumulativeData = _objectSpread({}, data);
    if (cumulativeDataSet.length > 0) cumulativeData[key] = data[key] + cumulativeDataSet[cumulativeDataSet.length - 1][key];
    cumulativeDataSet = [].concat(_toConsumableArray(cumulativeDataSet), [cumulativeData]);
    return cumulativeDataSet;
  }, []);
  return results;
}
var $efc110279246c456$exports = {};
$parcel$export($efc110279246c456$exports, "average", function () {
  return $efc110279246c456$export$cc6710ee5f037d57;
});
var $520fb4ec03cd9501$exports = {};
$parcel$export($520fb4ec03cd9501$exports, "safeDivide", function () {
  return $520fb4ec03cd9501$export$277aabc710d9a0ad;
});
function $520fb4ec03cd9501$export$277aabc710d9a0ad(numerator, denominator) {
  var value = numerator / denominator;
  return isFinite(value) ? value : 0;
}
function $efc110279246c456$export$cc6710ee5f037d57(item) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return $520fb4ec03cd9501$export$277aabc710d9a0ad(item[keys[0]], item[keys[1]]);
}
var $237709e97774e5de$exports = {};
$parcel$export($237709e97774e5de$exports, "rate", function () {
  return $237709e97774e5de$export$e8435ed7e8ba58fa;
});
var $8850a3df4d77aa80$exports = {};
$parcel$export($8850a3df4d77aa80$exports, "divide", function () {
  return $8850a3df4d77aa80$export$cd007d971a5a2143;
});
function $8850a3df4d77aa80$export$cd007d971a5a2143(numerator, denominator) {
  if (!denominator) return NaN; //Represents invalid value;
  return numerator / denominator;
}
function $237709e97774e5de$export$e8435ed7e8ba58fa(item) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return $8850a3df4d77aa80$export$cd007d971a5a2143(item[keys[0]], item[keys[1]]);
}
$parcel$exportWildcard($06d2d9de361ad358$exports, $bf39c630334f29ae$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $efc110279246c456$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $237709e97774e5de$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $520fb4ec03cd9501$exports);
$parcel$exportWildcard($06d2d9de361ad358$exports, $8850a3df4d77aa80$exports);
var $f1d7ffdf435118bb$exports = {};
var $2b426f67b59e8726$exports = {};
$parcel$export($2b426f67b59e8726$exports, "formatBytes", function () {
  return $2b426f67b59e8726$export$e1a3971de07c83b5;
});
var $b7f4fcabf3442813$exports = {};
$parcel$export($b7f4fcabf3442813$exports, "roundToPlaces", function () {
  return $b7f4fcabf3442813$export$e5391d7b13fe3535;
});
function $b7f4fcabf3442813$export$e5391d7b13fe3535(number, places) {
  var multiplier = Math.pow(10, places);
  return Math.round(number * multiplier) / multiplier;
}
var $ac7bd25d01e28e2d$exports = {};
$parcel$export($ac7bd25d01e28e2d$exports, "isNumber", function () {
  return $ac7bd25d01e28e2d$export$7e4aa119212bc614;
});
var $ac7bd25d01e28e2d$export$7e4aa119212bc614 = function $ac7bd25d01e28e2d$export$7e4aa119212bc614(value) {
  return isNaN(parseFloat(value)) === false || isFinite(value) === true;
};
var $2b426f67b59e8726$export$e1a3971de07c83b5 = $parcel$interopDefault($bctdY$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // Default case is Bytes
  var formatted = value;
  var suffix = 'B';
  var formatters = {
    PB: Math.pow(2, 50),
    TB: Math.pow(2, 40),
    GB: Math.pow(2, 30),
    MB: Math.pow(2, 20),
    KB: Math.pow(2, 10)
  };
  $parcel$interopDefault($bctdY$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString(undefined, {
    maximumSignificantDigits: 4
  })).concat(suffix);
});
var $c66c7baffc1c0dfc$exports = {};
$parcel$export($c66c7baffc1c0dfc$exports, "formatMilliseconds", function () {
  return $c66c7baffc1c0dfc$export$5daf09ba04077ce8;
});
var $c66c7baffc1c0dfc$export$5daf09ba04077ce8 = $parcel$interopDefault($bctdY$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // Default case is milliseconds
  var formatted = value;
  var suffix = 'ms';
  var formatters = {
    h: 3600000,
    m: 60000,
    s: 1000
  };
  $parcel$interopDefault($bctdY$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString()).concat(suffix);
});
var $2cb2128e0b9e1f2c$exports = {};
$parcel$export($2cb2128e0b9e1f2c$exports, "formatNumber", function () {
  return $2cb2128e0b9e1f2c$export$f5dd818bff069720;
});
var $2cb2128e0b9e1f2c$export$f5dd818bff069720 = $parcel$interopDefault($bctdY$lodash).memoize(function (value) {
  if (!$ac7bd25d01e28e2d$export$7e4aa119212bc614(value)) return value;
  // No suffix for default case
  var formatted = value;
  var suffix = '';
  var formatters = {
    B: Math.pow(10, 9),
    M: Math.pow(10, 6),
    K: 1000
  };
  $parcel$interopDefault($bctdY$lodash).forEach(formatters, function (unit, key) {
    if (value >= unit) {
      suffix = key;
      formatted = value / unit;
      return false;
    }
  });
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(formatted, 2).toLocaleString()).concat(suffix);
});
var $0a59e1cff196aa1f$exports = {};
$parcel$export($0a59e1cff196aa1f$exports, "formatYAxisPercent", function () {
  return $0a59e1cff196aa1f$export$f46f3370c2c30550;
});
var $0a59e1cff196aa1f$export$f46f3370c2c30550 = $parcel$interopDefault($bctdY$lodash).memoize(function (v) {
  if (typeof v === 'string') return v;
  if (isNaN(v)) return '---';
  v *= 100;
  return "".concat($b7f4fcabf3442813$export$e5391d7b13fe3535(v, v < 1 ? 3 : 1), "%");
});
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $2b426f67b59e8726$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $c66c7baffc1c0dfc$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $2cb2128e0b9e1f2c$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $0a59e1cff196aa1f$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $ac7bd25d01e28e2d$exports);
$parcel$exportWildcard($f1d7ffdf435118bb$exports, $b7f4fcabf3442813$exports);
var $5d9b09857b8fa08e$export$c3f418cdae11e815 = [$bctdY$sparkpostdesigntokens.tokens.color_blue_700, $bctdY$sparkpostdesigntokens.tokens.color_teal_600, $bctdY$sparkpostdesigntokens.tokens.color_purple_800, $bctdY$sparkpostdesigntokens.tokens.color_magenta_600, $bctdY$sparkpostdesigntokens.tokens.color_blue_900, $bctdY$sparkpostdesigntokens.tokens.color_yellow_500, $bctdY$sparkpostdesigntokens.tokens.color_gray_700, $bctdY$sparkpostdesigntokens.tokens.color_purple_500, $bctdY$sparkpostdesigntokens.tokens.color_gray_1000];
var $5d9b09857b8fa08e$var$injection = 'Injection';
var $5d9b09857b8fa08e$var$delivery = 'Delivery';
var $5d9b09857b8fa08e$var$deliverability = 'Deliverability';
var $5d9b09857b8fa08e$var$engagement = 'Engagement';
var $5d9b09857b8fa08e$export$2c76aca27257bcfa = [$5d9b09857b8fa08e$var$injection, $5d9b09857b8fa08e$var$delivery, $5d9b09857b8fa08e$var$deliverability, $5d9b09857b8fa08e$var$engagement];
var $5d9b09857b8fa08e$export$e143335c1543628 = {
  'Recipient Domain': 'domains',
  Campaign: 'campaigns',
  'Campaign (ID)': 'campaigns',
  'Campaign (Subject Line)': 'subject_campaigns',
  Template: 'templates',
  'Sending IP': 'sending_ips',
  'IP Pool': 'ip_pools',
  Subaccount: 'subaccounts',
  'Sending Domain': 'sending_domains',
  'Mailbox Provider': 'mailbox_providers',
  'Mailbox Provider Region': 'mailbox_provider_regions'
};
var $5d9b09857b8fa08e$export$938bb5fdbf904224 = $bctdY$lodash.invert($5d9b09857b8fa08e$export$e143335c1543628);
var $5d9b09857b8fa08e$export$3a28e3a2b7e54f6 = 'prefetchedKey';
var $5d9b09857b8fa08e$export$b62ef4c67ed4b184 = 'nonPrefetchedKey';
var $5d9b09857b8fa08e$export$d334702e3b05c761 = [_defineProperty({
  key: 'count_nonprefetched_rendered',
  label: 'Opens (Bottom Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the bottom open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_rendered'), _defineProperty({
  key: 'count_nonprefetched_unique_rendered',
  label: 'Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_unique_rendered'), _defineProperty({
  key: 'count_nonprefetched_initial_rendered',
  label: 'Opens (Top Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the top open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_initial_rendered'), _defineProperty({
  key: 'count_nonprefetched_unique_initial_rendered',
  label: 'Initial Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were initially rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_unique_initial_rendered'), _defineProperty({
  key: 'count_nonprefetched_unique_confirmed_opened',
  label: 'Unique Confirmed Opens',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true,
  isUniquePerTimePeriod: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'count_unique_confirmed_opened'), _defineProperty({
  key: 'nonprefetched_open_rate',
  label: 'Open Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_nonprefetched_unique_confirmed_opened', 'count_unique_confirmed_opened', 'count_accepted'],
  compute: function compute(_ref7) {
    var count_nonprefetched_unique_confirmed_opened = _ref7.count_nonprefetched_unique_confirmed_opened,
      count_unique_confirmed_opened = _ref7.count_unique_confirmed_opened,
      count_accepted = _ref7.count_accepted;
    var nonprefetched_opens = count_nonprefetched_unique_confirmed_opened;
    var nonprefetched_accepted = count_accepted - (count_unique_confirmed_opened - count_nonprefetched_unique_confirmed_opened);
    return $237709e97774e5de$export$e8435ed7e8ba58fa({
      nonprefetched_opens: nonprefetched_opens,
      nonprefetched_accepted: nonprefetched_accepted
    }, ['nonprefetched_opens', 'nonprefetched_accepted']);
  },
  description: 'Percentage of Accepted emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true
}, $5d9b09857b8fa08e$export$3a28e3a2b7e54f6, 'open_rate')];
var $5d9b09857b8fa08e$export$8837f4fc672e936d = [{
  key: 'count_targeted',
  label: 'Targeted',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails requested or relayed to SparkPost. Includes Injected and Rejected.',
  inSummary: true
}, {
  key: 'count_injected',
  label: 'Injected',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails successfully generated or relayed through SparkPost.',
  inSummary: true
}, {
  key: 'count_sent',
  label: 'Sent',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that were attempted to be delivered. Includes Deliveries and Bounces.',
  inSummary: true
}, {
  key: 'count_accepted',
  label: 'Accepted',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: "Number of emails delivered that didn't subsequently bounce (Out-of-Band).",
  inSummary: true
}, {
  key: 'count_delivered_first',
  label: 'Delivered 1st Attempt',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails delivered on the first attempt.',
  inSummary: true
}, {
  key: 'count_delivered_subsequent',
  label: 'Delivered 2+ Attempts',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails delivered that required more than one attempt.',
  inSummary: true
}, {
  key: 'count_spam_complaint',
  label: 'Spam Complaints',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of spam complaints received from mailbox providers.',
  notApplicableFor: ['nodes'],
  inSummary: true
}, {
  key: 'spam_complaint_rate',
  label: 'Spam Complaint Rate',
  unit: 'percent',
  category: $5d9b09857b8fa08e$var$engagement,
  computeKeys: ['count_spam_complaint', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Spam Complaints.',
  inSummary: true
}, _defineProperty({
  key: 'count_rendered',
  label: 'Opens (Bottom Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the bottom open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_rendered'), _defineProperty({
  key: 'count_unique_rendered',
  label: 'Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_unique_rendered'), _defineProperty({
  key: 'count_initial_rendered',
  label: 'Opens (Top Pixel)',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times the top open tracking pixel was rendered.',
  inSummary: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_initial_rendered'), _defineProperty({
  key: 'count_unique_initial_rendered',
  label: 'Initial Unique Rendered',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Total number of messages that were initially rendered at least once.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  deprecated: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_unique_initial_rendered'), _defineProperty({
  key: 'count_unique_confirmed_opened',
  label: 'Unique Confirmed Opens',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true,
  isUniquePerTimePeriod: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'count_nonprefetched_unique_confirmed_opened'), {
  key: 'count_clicked',
  label: 'Clicks',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times that links were clicked across all emails.',
  inSummary: true,
  tab: 'links'
}, {
  key: 'count_unique_clicked',
  label: 'Unique Clicks',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of emails that had at least one link clicked.',
  inSummary: true,
  isUniquePerTimePeriod: true,
  tab: 'links'
}, {
  key: 'count_bounce',
  label: 'Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of bounced emails, not including Admin Bounces. Includes all In-Band and Out-of-Band Bounces.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_hard_bounce',
  label: 'Hard Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that bounced due to permanent delivery issues.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_soft_bounce',
  label: 'Soft Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that bounced due to temporary delivery issues.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_block_bounce',
  label: 'Block Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Total number of Bounced messages due to an IP block.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_admin_bounce',
  label: 'Admin Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that were bounced by SparkPost. Not counted in Bounces.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_undetermined_bounce',
  label: 'Undetermined Bounces',
  type: 'total',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'number',
  description: 'Number of emails that bounced due to undetermined reasons.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'count_rejected',
  label: 'Rejected',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that were rejected by SparkPost. Includes Policy Rejections, Generation Rejections, Generation Failures.',
  inSummary: true,
  tab: 'rejection'
}, {
  key: 'count_policy_rejection',
  label: 'Policy Rejections',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that were rejected by SparkPost due to policy reasons.',
  inSummary: true,
  tab: 'rejection'
}, {
  key: 'count_generation_failed',
  label: 'Generation Failures',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that failed generation due to technical reasons.',
  inSummary: true,
  tab: 'rejection'
}, {
  key: 'count_unsubscribe',
  label: 'Unsubscribes',
  type: 'total',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'number',
  description: 'Number of times a recipient clicked a tagged unsubscribe link or used the list unsubscribe header.',
  inSummary: true
}, {
  key: 'count_generation_rejection',
  label: 'Generation Rejections',
  type: 'total',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'number',
  description: 'Number of emails that failed generation due to policy reasons.',
  inSummary: true,
  tab: 'rejection'
}, {
  //TODO: Remove once deliverability metrics are released
  key: 'accepted_rate',
  label: 'Accepted Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_accepted', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent messages that were accepted.',
  inSummary: true
}, _defineProperty({
  key: 'open_rate',
  label: 'Open Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unique_confirmed_opened', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true
}, $5d9b09857b8fa08e$export$b62ef4c67ed4b184, 'nonprefetched_open_rate'), {
  key: 'prefetched_open_rate',
  label: 'Open Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unique_confirmed_opened', 'count_accepted', 'count_nonprefetched_unique_confirmed_opened'],
  compute: function compute(_ref15) {
    var count_nonprefetched_unique_confirmed_opened = _ref15.count_nonprefetched_unique_confirmed_opened,
      count_unique_confirmed_opened = _ref15.count_unique_confirmed_opened,
      count_accepted = _ref15.count_accepted;
    var nonprefetched_opens = count_nonprefetched_unique_confirmed_opened;
    var nonprefetched_accepted = count_accepted - (count_unique_confirmed_opened - count_nonprefetched_unique_confirmed_opened);
    return $237709e97774e5de$export$e8435ed7e8ba58fa({
      nonprefetched_opens: nonprefetched_opens,
      nonprefetched_accepted: nonprefetched_accepted
    }, ['nonprefetched_opens', 'nonprefetched_accepted']);
  },
  description: 'Percentage of Accepted emails that had any tracking pixel rendered or had a link clicked.',
  inSummary: true
}, {
  key: 'click_through_rate',
  label: 'Click-through Rate',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unique_clicked', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that had at least one link selected.',
  inSummary: true,
  tab: 'links'
}, {
  key: 'bounce_rate',
  label: 'Bounce Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent messages that Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'hard_bounce_rate',
  label: 'Hard Bounce Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_hard_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent emails that Hard Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'soft_bounce_rate',
  label: 'Soft Bounce Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_soft_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent emails that Soft Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'block_bounce_rate',
  label: 'Block Bounce Rate',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_block_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent messages that Block Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'admin_bounce_rate',
  label: 'Admin Bounce Rate',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'percent',
  computeKeys: ['count_admin_bounce', 'count_targeted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Targeted messages that Admin Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'undetermined_bounce_rate',
  label: 'Undetermined Bounce Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_undetermined_bounce', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Sent emails that Undetermined Bounced.',
  inSummary: true,
  tab: 'bounce'
}, {
  key: 'unsubscribe_rate',
  label: 'Unsubscribe Rate',
  category: $5d9b09857b8fa08e$var$engagement,
  unit: 'percent',
  computeKeys: ['count_unsubscribe', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that resulted in unsubscribes.',
  inSummary: true
}, {
  key: 'count_delayed',
  label: 'Delayed',
  category: $5d9b09857b8fa08e$var$delivery,
  type: 'total',
  unit: 'number',
  description: "Number of emails that were temporarily rejected by a recipient's mailbox provider.",
  inSummary: true,
  tab: 'delayed'
}, {
  key: 'delayed_rate',
  label: 'Delayed Rate',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'percent',
  computeKeys: ['count_delayed_first', 'count_accepted'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Accepted emails that were delayed on the first delivery attempt.',
  inAnalyticsReport: true,
  tab: 'delayed'
}, {
  key: 'rejected_rate',
  label: 'Rejection Rate',
  category: $5d9b09857b8fa08e$var$injection,
  unit: 'percent',
  computeKeys: ['count_rejected', 'count_sent'],
  compute: $237709e97774e5de$export$e8435ed7e8ba58fa,
  description: 'Percentage of Targeted emails that were rejected.',
  inAnalyticsReport: true,
  tab: 'rejection'
}, {
  key: 'count_delayed_first',
  label: 'Delayed 1st Attempt',
  category: $5d9b09857b8fa08e$var$delivery,
  type: 'total',
  unit: 'number',
  description: 'Number of emails that were delayed on 1st delivery attempt.',
  inSummary: true,
  tab: 'delayed'
}, {
  key: 'avg_delivery_time_first',
  label: 'Avg Latency 1st Attempt',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'milliseconds',
  computeKeys: ['total_delivery_time_first', 'count_delivered_first'],
  compute: $efc110279246c456$export$cc6710ee5f037d57,
  description: 'Average delivery time in milliseconds (latency) for emails delivered on the first attempt.',
  inSummary: true
}, {
  key: 'avg_delivery_time_subsequent',
  label: 'Avg Latency 2+ Attempts',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'milliseconds',
  computeKeys: ['total_delivery_time_subsequent', 'count_delivered_subsequent'],
  compute: $efc110279246c456$export$cc6710ee5f037d57,
  description: 'Average delivery time in milliseconds (latency) for emails delivered that required more than one attempt.',
  inSummary: true
}, {
  key: 'avg_msg_size',
  label: 'Avg Delivery Message Size',
  category: $5d9b09857b8fa08e$var$delivery,
  unit: 'bytes',
  computeKeys: ['total_msg_volume', 'count_delivered'],
  compute: $efc110279246c456$export$cc6710ee5f037d57,
  description: 'Average size of delivered emails, including attachments, in bytes.',
  inSummary: true
}, {
  key: 'total_msg_volume',
  label: 'Delivery Message Volume',
  category: $5d9b09857b8fa08e$var$delivery,
  type: 'total',
  unit: 'bytes',
  description: 'Total size of delivered emails including attachments, in bytes.',
  inSummary: true
}, /* below are metrics that never show in the summary report, but are needed when making API calls from the Metrics service */{
  key: 'count_inband_bounce',
  label: 'In-band Bounces',
  type: 'total',
  unit: 'number',
  description: 'Number of emails that bounced on delivery attempt.',
  category: $5d9b09857b8fa08e$var$delivery,
  inAnalyticsReport: true,
  tab: 'bounce'
}, {
  key: 'count_outofband_bounce',
  label: 'Out-of-band Bounces',
  type: 'total',
  unit: 'number',
  description: 'Number of emails that bounced subsequent to a successful delivery.',
  category: $5d9b09857b8fa08e$var$delivery,
  inAnalyticsReport: true,
  tab: 'bounce'
}, {
  key: 'count_raw_clicked',
  type: 'total',
  unit: 'number',
  description: 'Total number of messages which had at least one link selected one or more times.'
}, {
  key: 'count_inbox',
  label: 'Inbox Folder Count',
  type: 'total',
  unit: 'number',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref16) {
    var count_inbox_panel = _ref16.count_inbox_panel,
      count_inbox_seed = _ref16.count_inbox_seed;
    return count_inbox_panel + count_inbox_seed;
  },
  computeKeys: ['count_inbox_panel', 'count_inbox_seed'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of seed and panel messages delivered to the inbox.'
}, {
  key: 'count_spam',
  label: 'Spam Folder Count',
  type: 'total',
  unit: 'number',
  compute: function compute(_ref17) {
    var count_spam_panel = _ref17.count_spam_panel,
      count_spam_seed = _ref17.count_spam_seed;
    return count_spam_panel + count_spam_seed;
  },
  computeKeys: ['count_spam_panel', 'count_spam_seed'],
  category: $5d9b09857b8fa08e$var$deliverability,
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of seed and panel messages delivered to the spam folder.'
}, {
  key: 'inbox_folder_rate',
  label: 'Inbox Folder Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref18) {
    var count_inbox_panel = _ref18.count_inbox_panel,
      count_inbox_seed = _ref18.count_inbox_seed,
      count_spam_panel = _ref18.count_spam_panel,
      count_spam_seed = _ref18.count_spam_seed;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_inbox_panel + count_inbox_seed, count_inbox_panel + count_inbox_seed + count_spam_panel + count_spam_seed);
  },
  computeKeys: ['count_inbox_panel', 'count_inbox_seed', 'count_spam_panel', 'count_spam_seed'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of seed and panel messages delivered to the inbox.'
}, {
  key: 'spam_folder_rate',
  label: 'Spam Folder Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref19) {
    var count_inbox_panel = _ref19.count_inbox_panel,
      count_inbox_seed = _ref19.count_inbox_seed,
      count_spam_panel = _ref19.count_spam_panel,
      count_spam_seed = _ref19.count_spam_seed;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_spam_panel + count_spam_seed, count_inbox_panel + count_inbox_seed + count_spam_panel + count_spam_seed);
  },
  computeKeys: ['count_inbox_panel', 'count_inbox_seed', 'count_spam_panel', 'count_spam_seed'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of seed and panel messages delivered to the spam folder.'
}, {
  key: 'count_moved_to_inbox',
  label: 'Moved to Inbox Count',
  type: 'total',
  unit: 'number',
  category: $5d9b09857b8fa08e$var$deliverability,
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of panel messages delivered to the spam folder but then moved to the inbox.'
}, {
  key: 'count_moved_to_spam',
  label: 'Moved to Spam Count',
  type: 'total',
  unit: 'number',
  category: $5d9b09857b8fa08e$var$deliverability,
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Number of panel messages delivered to the inbox but then moved to the spam folder.'
}, {
  key: 'moved_to_inbox_rate',
  label: 'Moved to Inbox Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref20) {
    var count_moved_to_inbox = _ref20.count_moved_to_inbox,
      count_spam_panel = _ref20.count_spam_panel;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_moved_to_inbox, count_spam_panel);
  },
  computeKeys: ['count_moved_to_inbox', 'count_spam_panel'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of panel messages delivered to the spam folder but then moved to the inbox.'
}, {
  key: 'moved_to_spam_rate',
  label: 'Moved to Spam Rate',
  unit: 'percent',
  type: 'percentage',
  category: $5d9b09857b8fa08e$var$deliverability,
  compute: function compute(_ref21) {
    var count_moved_to_spam = _ref21.count_moved_to_spam,
      count_inbox_panel = _ref21.count_inbox_panel;
    return $8850a3df4d77aa80$export$cd007d971a5a2143(count_moved_to_spam, count_inbox_panel);
  },
  computeKeys: ['count_moved_to_spam', 'count_inbox_panel'],
  inAnalyticsReport: true,
  product: 'deliverability',
  description: 'Percentage of panel messages delivered to the inbox but then moved to the spam folder.'
}];
var $5d9b09857b8fa08e$export$e02e63fda0b3a81c = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (metric) {
  return metric.product === 'deliverability';
});
var $5d9b09857b8fa08e$export$13acb3da2d2f7436 = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref22) {
  var tab = _ref22.tab;
  return tab && tab === 'bounce';
});
var $5d9b09857b8fa08e$export$f50be4e64d945ebd = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref23) {
  var tab = _ref23.tab;
  return tab && tab === 'rejection';
});
var $5d9b09857b8fa08e$export$dce03f1dce1dbb81 = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref24) {
  var tab = _ref24.tab;
  return tab && tab === 'delayed';
});
var $5d9b09857b8fa08e$export$20e66e155200ce = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (_ref25) {
  var tab = _ref25.tab;
  return tab && tab === 'links';
});
var $5d9b09857b8fa08e$export$93a3932e55e08b73 = ['count_sent', 'count_bounce', 'count_inband_bounce', 'count_outofband_bounce', 'count_admin_bounce', 'count_targeted'];
var $5d9b09857b8fa08e$export$3153a1856b13a66c = ['count_accepted', 'count_delayed', 'count_delayed_first'];
var $5d9b09857b8fa08e$export$d83bf8754cc127f4 = ['count_rejected', 'count_targeted'];
var $5d9b09857b8fa08e$export$88586c7bba3bcfca = ['count_accepted', 'count_clicked', 'count_sent', 'count_unique_clicked', 'count_unique_confirmed_opened'];
var $5d9b09857b8fa08e$export$dfab43b0ae5b287f = ['count_clicked', 'count_raw_clicked'];
var $5d9b09857b8fa08e$export$3b5f7e0951e03e2d = ['count_clicked', 'count_raw_clicked'];
var $5d9b09857b8fa08e$export$56c8589eebb696c7 = ['count_bounce'];
var $5d9b09857b8fa08e$export$871de8747c9eaa88 = $5d9b09857b8fa08e$export$8837f4fc672e936d.reduce(function (accumulator, metric) {
  return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, metric.key, metric));
}, {});
var $5d9b09857b8fa08e$var$selectableMetrics = $5d9b09857b8fa08e$export$8837f4fc672e936d.filter(function (metric) {
  return (metric.inSummary || metric.inAnalyticsReport) && metric.category && !metric.deprecated;
});
var $5d9b09857b8fa08e$var$categoriesObj = $5d9b09857b8fa08e$export$2c76aca27257bcfa.reduce(function (accumulator, current) {
  accumulator[current] = [];
  return accumulator;
}, {});
var $5d9b09857b8fa08e$var$categorizedMetrics = $5d9b09857b8fa08e$var$selectableMetrics.reduce(function (accumulator, current) {
  accumulator[current.category].push(current);
  return accumulator;
}, $5d9b09857b8fa08e$var$categoriesObj);
var $5d9b09857b8fa08e$export$24fdeceee7dce9f = $5d9b09857b8fa08e$export$2c76aca27257bcfa.map(function (category) {
  return {
    category: category,
    metrics: $5d9b09857b8fa08e$var$categorizedMetrics[category].sort(function (a, b) {
      return a.label.localeCompare(b.label);
    })
  }; //Sorts each metric alphabetically by label
});

var $5d9b09857b8fa08e$export$316876556a26de9d = {
  inbox_folder_rate: {
    label: 'Inbox Folder Rate Industry Benchmark',
    helpText: 'When on, inbox folder rate benchmark data for industry and mailbox provider selected below will display on graph.'
  }
};
var $5d9b09857b8fa08e$export$224b14d28c9ae256 = {
  number: {
    label: 'Count',
    yAxisFormatter: $2cb2128e0b9e1f2c$export$f5dd818bff069720
  },
  percent: {
    label: 'Percent',
    yAxisFormatter: $0a59e1cff196aa1f$export$f46f3370c2c30550
  },
  milliseconds: {
    label: 'Time',
    yAxisFormatter: $c66c7baffc1c0dfc$export$5daf09ba04077ce8
  },
  bytes: {
    label: 'Size, in Bytes',
    yAxisFormatter: $2b426f67b59e8726$export$e1a3971de07c83b5
  }
};